import React from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Divider,
  Flex,
  Skeleton,
} from '@patternfly/react-core';
import { LandingLayout } from 'components/Landing/LandingLayout';
import SidebarSkeleton from 'components/Landing/SidebarSkeleton';

type LandingPageSkeletonProps = {
  /** Link for the first breadcrumb item (e.g. Catalog, Sessions) */
  breadcrumbParentLink?: React.ReactNode;
  /** When false, omits the metadata section in the sidebar (e.g. for Premium session landing) */
  sidebarShowMetadata?: boolean;
};

/**
 * Reusable skeleton loading state for landing pages (Course and Premium).
 * Matches the layout of the overview page: breadcrumb, header, main content, and sidebar.
 */
const LandingPageSkeleton: React.FC<LandingPageSkeletonProps> = ({
  breadcrumbParentLink,
  sidebarShowMetadata = true,
}) => (
  <>
    <LandingLayout.Breadcrumb>
      <Breadcrumb>
        {breadcrumbParentLink && (
          <BreadcrumbItem>{breadcrumbParentLink}</BreadcrumbItem>
        )}
        <BreadcrumbItem isActive>
          <Skeleton width="190px" height="20px" />
        </BreadcrumbItem>
      </Breadcrumb>
    </LandingLayout.Breadcrumb>

    <div className="overview__header">
      <Skeleton width="50%" height="28px" />
      <Divider component="div" className="overview__divider" />
    </div>

    <LandingLayout.Content>
      <LandingLayout.Main>
        <Flex
          direction={{ default: 'column' }}
          gap={{ default: 'gapMd' }}
          style={{ paddingTop: 'var(--pf-v5-global--spacer--md)' }}
        >
          <Skeleton width="120px" height="36px" />
          <Skeleton width="80px" height="24px" />
          <Skeleton width="100%" height="20px" />
          <Skeleton width="90%" height="20px" />
          <Skeleton width="95%" height="20px" />
          <Skeleton width="85%" height="20px" />
          <Skeleton width="100%" height="20px" />
          <Skeleton width="75%" height="20px" />
          <Skeleton width="66%" height="20px" />
        </Flex>
      </LandingLayout.Main>

      <LandingLayout.Sidebar>
        <SidebarSkeleton showMetadata={sidebarShowMetadata} />
      </LandingLayout.Sidebar>
    </LandingLayout.Content>
  </>
);

export default LandingPageSkeleton;
